

const login = async (formData) => {

 try {
   
    const response = await fetch(`https://campus.acetians.in/api/v3/signin`, {
      method: "POST",
      body:formData,
   
    });

    console.log("Response from blogPost:", response);

    return await response.json();
  } catch (error) {
    console.error("Error following user:", error);
    return { success: false,  message: "Following failed" };
  }

};

export default login
